/**
 * Dependencies.
 */
import { BaseModel, endpoint } from '@prz-dp/services';

import AddressModel from '@/api/address/address.model';
import PackageModel from '@/api/package/package.model';

/**
 * Export `DeliveryModel`.
 */
@endpoint('delivery')
export default class DeliveryModel extends BaseModel {
  /**
   * Properties.
   */
  id: number;

  address: AddressModel;

  client: {
    name: string;
  };

  expectedDeliveryDate: string;

  numberPackages?: number;

  orderCode: string;

  packages: PackageModel[];

  paymentPending?: boolean;

  trackingNumber: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<DeliveryModel>) {
    super(data);
  }
}
